import React from 'react';
import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';

const BreadcrumbsData = ({ breadcrumbs = [] } = {}) => {
  const schema = {
    '@context': 'http://schema.org/',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.map((crumb, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: crumb.name,
      item: crumb.url,
    })),
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

BreadcrumbsData.propTypes = {
  breadcrumbs: PropTypes.array,
};

export default BreadcrumbsData;
